import React from "react";
import "../App.css"
import HeroSection from "../components/Hero/Hero"



function Home(){
    return (
        <>
            <HeroSection/>
        </>
    )
}
export default Home;